import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import { AuthService } from '../auth.service';
import { AppComponent } from '../app.component';
import { DomSanitizer } from '@angular/platform-browser';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Platform } from '@angular/cdk/platform';

@Component({
  selector: 'app-add-bank-details',
  templateUrl: './add-bank-details.component.html',
  styleUrls: ['./add-bank-details.component.scss'],
})
export class AddBankDetailsComponent {
  url;
  id;
  loader:boolean = true;
  userObj;
  firstName;
  bankName;
  branch;
  accountNbr;
  ifsc;
  constructor(public service: ApiService,
    public router: Router,
    public handler: HandlerService,
    public auth: AuthService,
    public app: AppComponent,
    public sanitizer: DomSanitizer,
    public bottomSheet: MatBottomSheet,
     public santinzer: DomSanitizer,
      public platform: Platform) { }

      ionViewWillEnter(){
        this.url = window.location.href;
        this.id = this.url.split('/').pop();
        this.service.getAddressById(this.id).subscribe(res => {
          this.userObj = res;
          if(this.userObj.bankDetails){
            if(this.userObj.bankDetails[0]){
              this.firstName = this.userObj.bankDetails[0].accntHolderName;
              this.bankName = this.userObj.bankDetails[0].bankName;
              this.branch = this.userObj.bankDetails[0].branch;
              this.accountNbr = this.userObj.bankDetails[0].accNumb;
              this.ifsc = this.userObj.bankDetails[0].ifsc;
            }
          }
          this.loader = false;
        },err => {
          this.handler.err(err);
          this.loader = false;
        })
        
      }

back(){
  this.router.navigate(['vendorProfile/',this.id])
}


UpdateProfile(){
  this.loader = true;
  this.url = window.location.href;
  this.id = this.url.split('/').pop();
     var x ={
      "accntHolderName": this.firstName,
      "bankName": this.bankName,
      "branch": this.branch,
      "accNumb": this.accountNbr,
      "activeInd": true,
      "ifsc": this.ifsc,
      "userId": this.id
     }
     if(!this.userObj.bankDetails){
       Object.assign(this.userObj,{bankDetails:[]})
       this.userObj.bankDetails.push(x)
     }else{
       this.userObj.bankDetails[0]=x
     }

   this.service.postProfileDetails(this.id,this.userObj).subscribe(res=>{
     this.loader = false;
   this.handler.res('Bank Details Updated Successfully');
   this.router.navigate(['vendorProfile/',this.id])
   this.ionViewWillEnter();
  }, err => {
   this.handler.err(err);
   this.loader=false;
 })
}

}
